// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComparativoFranquias_AggregadoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/comparativo_franquias/buscaDados.
 *
 * The model (Comparativo_franquias_model::buscaDados) reduces the per-franchise
 * comparativo view into exactly four aggregate sections — `maximos`, `minimos`,
 * `somas`, `medias`. The four section keys are FIXED. Each section is a map
 * keyed by the source view column name (numero_orcamentos, valor_orcamentos,
 * entradas, falta_faturar, previsao_faturamento, numero_clientes, ticket_medio,
 * compromissos_total, compromissos_realizados, despesas) to a uniform cell
 * shape {valor, owner?, coluna} captured by ComparativoFranquias_AggregadoCellRow.
 */
import type { ComparativoFranquias_AggregadoCellRow } from './ComparativoFranquias_AggregadoCellRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ComparativoFranquias_AggregadoResponseDados {
maximos: Record<string, ComparativoFranquias_AggregadoCellRow>
minimos: Record<string, ComparativoFranquias_AggregadoCellRow>
somas: Record<string, ComparativoFranquias_AggregadoCellRow>
medias: Record<string, ComparativoFranquias_AggregadoCellRow>
}

export type ComparativoFranquias_AggregadoResponse = ApiResponse<ComparativoFranquias_AggregadoResponseDados>;

registerResponseContract('ComparativoFranquias_AggregadoResponse', {
  maximos: { type: 'object',  required: true },
  minimos: { type: 'object',  required: true },
  somas:   { type: 'object',  required: true },
  medias:  { type: 'object',  required: true },
})
